import { createRootRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Layout, ErrorHandler } from '@/components';
import { RumClient } from '@/services';

const searchSchema = z.object({
  q: z.union([z.string(), z.number().transform(String)]).optional(),
}).passthrough();

export const Route = createRootRoute({
  component: Layout,
  validateSearch: (search) => {
    let result: z.infer<typeof searchSchema>;

    try {
      result = searchSchema.parse(search);
    } catch (error) {
      RumClient.recordError(error);
      throw new Error('Invalid search parameters');
    }

    return result;
  },
  errorComponent: ({ error }) => (
    <ErrorHandler
      error={{ message: error?.message || 'Page not found' }}
      resetErrorBoundary={() => console.log('error boundary reset')}
    />
  ),
});
